import type { ReferenceDocumentView } from "@/lib/api/generated/casedb";
import { useReferenceDocumentLinks } from "../hooks/useReferenceDocumentLinks";

interface Props { documents?: ReferenceDocumentView[]; }

/**
 * One button per local reference document. Shared by Case Review and Submission,
 * so document-opening behaves identically on both screens; the state it draws
 * lives in {@link useReferenceDocumentLinks}, not here.
 */
export function ReferenceDocumentLinks({ documents = [] }: Props) {
  const { loadingId, error, openDocument } = useReferenceDocumentLinks();

  return <div className="flex flex-col gap-1 text-xs">
    {documents.map((document: ReferenceDocumentView) => <button
      key={document.document_id} type="button" disabled={loadingId !== null}
      className="text-left text-viz-blue hover:underline break-all disabled:opacity-50"
      onClick={() => { void openDocument(document); }}
      title={`Open ${document.file_name ?? "reference"} (Section ${document.section ?? "4.8"}, ${document.language ?? ""})`}>
      {document.file_name}{loadingId === document.document_id ? " — Opening…" : ""}
    </button>)}
    {error && <span role="alert" className="text-destructive">{error}</span>}
  </div>;
}
